import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { IconButton, Menu, MenuItem, withStyles } from '@material-ui/core'
import { MoreHoriz, MoreVert, Delete, Edit } from '@material-ui/icons'
import styles from '../styles'
import { deleteSignupForm } from 'actions/signupForm'
import language from 'utils/vast-languagepack'
import { toggleDeleteDialog } from 'actions/view'

export default connect(null, (dispatch) =>
  bindActionCreators({ deleteSignupForm, toggleDeleteDialog }, dispatch),
)(
  withStyles(styles)(
    class SimpleMenu extends Component {
      state = {
        anchorEl: null,
      }

      handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget })
      }

      handleClose = () => {
        this.setState({ anchorEl: null })
      }

      handleDeleteClick = () => {
        this.setState({ anchorEl: null })
        this.props.deleteSignupForm(this.props.formID)
      }

      confirmDelete = function () {
        return window.confirm(`Delete ${this.props.formName}?`)
      }

      render() {
        const { anchorEl } = this.state
        const {
          classes,
          horiz,
          vert,
          formID,
          history,
          expanded,
          idx,
          toggleDeleteDialog,
          formName,
        } = this.props

        return (
          <div>
            <IconButton
              aria-owns={anchorEl ? `deleteMenu${formID}` : undefined}
              aria-haspopup="true"
              onClick={this.handleClick}
              style={
                horiz
                  ? {
                      display: expanded === idx ? 'inline-flex' : 'none',
                    }
                  : vert
                  ? { position: 'absolute', top: 0, right: 0 }
                  : null
              }
              className={horiz ? classes.expandPanelDetailsIconSecondary : null}
            >
              {horiz ? <MoreHoriz /> : null}
              {vert ? <MoreVert /> : null}
            </IconButton>
            <Menu
              id={`deleteMenu${formID}`}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem onClick={() => history.push(`forms/${formID}`)}>
                <Edit className={classes.leftIcon} />
                {language.signupform.edit}
              </MenuItem>
              <MenuItem
                onClick={() =>
                  toggleDeleteDialog({
                    id: formID,
                    name: formName,
                    entityType: 'signupform',
                  })
                }
              >
                <Delete className={classes.leftIcon} />
                {language.signupform.delete}
              </MenuItem>
            </Menu>
          </div>
        )
      }
    },
  ),
)
